"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MediaWrapper;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function MediaWrapper(_ref) {
  var index = _ref.index,
    imageUrl = _ref.imageUrl;
  var sourceUrl = {
    src: imageUrl
  };
  var backgroundImage = {
    sm: sourceUrl,
    md: sourceUrl,
    lg: sourceUrl,
    xl: sourceUrl
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    paddingLevel: 0,
    allowOverflow: false,
    dataAttributes: {
      'data-testid': "offer-card-image-".concat(index)
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SkinnyBanner, {
    heading: {
      text: ''
    },
    backgroundImage: backgroundImage
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    paddingLevel: 0,
    allowOverflow: false,
    enableOverlay: false,
    backgroundImage: backgroundImage,
    dataAttributes: {
      'data-testid': "offer-card-image-".concat(index)
    }
  })));
}
MediaWrapper.propTypes = {
  index: _propTypes.default.number,
  imageUrl: _propTypes.default.string
};